var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12501 0H10.9375L10.9375 15.7576C10.9375 16.0886 11.3164 16.2727 11.5722 16.0659L14.8438 13.4211L18.1154 16.0659C18.3711 16.2727 18.75 16.0886 18.75 15.7576L18.75 0C20.4759 0 21.875 1.41384 21.875 3.1579L21.875 23.6842C21.875 25.4283 20.4759 26.8421 18.75 26.8421H2.34375L3.90625 28.4211H19.5312C21.6886 28.4211 23.4375 26.6538 23.4375 24.4737L23.4375 4.73684C24.3004 4.73684 25 5.44376 25 6.31579L25 24.4737C25 27.5258 22.5516 30 19.5312 30H3.77221C3.35781 30 2.96038 29.8336 2.66735 29.5375L0.457646 27.3046C0.16462 27.0085 0 26.6068 0 26.1881L8.19564e-06 3.15789C8.19564e-06 1.41384 1.39912 0 3.12501 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.7903d2c10089c9679794e0b3c60c9d8e.svg";
export { ForwardRef as ReactComponent };